<h2 mat-dialog-title class="av-section-title">{{ data.title | translate }}</h2>

<mat-dialog-content>
  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="note-body">
      <span class="av-meta">{{ 'backoffice.organizations.notes.dialog.body_label' | translate }}</span>
      <textarea
        id="note-body"
        class="av-field"
        rows="6"
        [attr.maxlength]="bodyMax"
        formControlName="body"
      ></textarea>
    </label>

    <label class="d-flex align-items-center gap-2">
      <input type="checkbox" formControlName="pinned" />
      <span class="av-section-hint">
        {{ 'backoffice.organizations.notes.dialog.pin_label' | translate }}
      </span>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="cancel()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
  >
    {{ 'backoffice.organizations.notes.dialog.confirm' | translate }}
  </button>
</mat-dialog-actions>
